// libraries.
import { useEffect } from 'react';
import { toast } from 'react-toastify';

// hooks.
import { useCurrentOrchestrator } from '@domains/orchestrator-pricing-committee/hooks/useCurrentOrchestrator';

// components.
import { OrchestratorSteps } from './components/OrchestratorSteps/OrchestratorSteps';

export const OrchestratorTracker = () => {
  const { currentOrchestrator } = useCurrentOrchestrator();

  const { data, isFetching } = currentOrchestrator;

  useEffect(() => {
    if (isFetching) {
      toast.info('Cargando orquestador...', {
        toastId: 'loading-orchestrator',
      });
    }
  }, [isFetching]);

  if (!data) {
    return <div>No data found.</div>;
  }

  return <OrchestratorSteps data={data} />;
};
